import AxiosJob from '@/services/api/job/axios_job'

export default {
  createJob: (data) => {
    return AxiosJob.post('job', data)
  },

  updateJob: (jobId, data) => {
    return AxiosJob.put(`job/${jobId}`, data)
  },

  getAllJobs: (params) => {
     return AxiosJob.get('job', { params })
  },

  getJob: (jobId) => {
    return AxiosJob.get(`job/${jobId}`)
  },

  getCustomerVisibleActors: (jobId, laneId) => {
    return AxiosJob.get(`job/${jobId}/customer-visible-actors`, {
      params: { lane_id: laneId }
    })
  },

  searchJob: (params) => {
    return AxiosJob.get(`job/search`, { params } )
  },

  moveJobToPool: (data) => {
    return AxiosJob.put(`job/move-to-pool`, data)
  },

  changeJobSlot: (data) => {
    return AxiosJob.put(`job/change-slot`, data)
  },

  // Forward job to next lane (fallback when move-to-pool is unavailable)
  forwardJob: (jobId) => {
    return AxiosJob.put(`job/${jobId}/forward`)
  },

  deleteJob: (jobId) => {
    return AxiosJob.delete(`job/${jobId}`)
  },

  createSubtask: (data) => {
    return AxiosJob.post(`job/create-subtask`, data)
  },

  finishSubtask: (jobId) => {
    return AxiosJob.put(`job/finish-subtask/${jobId}`)
  },

  finishJob: (jobId) => {
    return AxiosJob.put(`job/finish/${jobId}`)
  },

  reopenJob: (jobId) => {
    return AxiosJob.put(`job/reopen/${jobId}`)
  },

  /**
   * Generates one scoped markup token for each external approver.
   *
   * The Job API receives the approvers and the expiration in a single payload.
   */
  createExternalMarkupLinks: (jobId, emails, expiresAt) => {
    return AxiosJob.post(`job/external/markup/${jobId}`, {
      emails,
      expires_at: expiresAt
    })
  },

}
